import { bambiApi } from 'src/common/external/bambi-api/routesApi';

bambiApi.enhanceEndpoints({
  addTagTypes: [
    'trips',
    'dispatch',
    'run-bambi-run',
    'requested-trip-count',
    'will-call-count',
  ],
  endpoints: {
    routesRouteBambiRouteCreate: {
      invalidatesTags: [
        'routes',
        'trips',
        'dispatch',
        'run-bambi-run',
        'requested-trip-count',
        'will-call-count',
      ],
    },
  },
});
